<template>

  <form action="none" class="DownloadForm" @submit.prevent="submitForm">

    <div class="formFields">
      <FullNameField v-bind="{ disabled }" ref="fullName" />
      <EmailField v-bind="{ disabled }" ref="email" />
      <PhoneField v-bind="{ disabled }" ref="phone" />
    </div>

    <div class="formFooter">
      <button class="button" v-show="submissionStatus !== 'submitted'" v-bind="{ disabled }">
        {{ localeStrings.downloadButtonText }}
      </button>
      <div class="statusMessageSubmitted" v-show="submissionStatus === 'submitted'">
        <span class="submittedText">{{ localeStrings.downloadConfirmationText }}</span>
      </div>
      <div class="statusMessageFailed" v-show="submissionStatus === 'failed'">
        {{ localeStrings.submissionErrorText }}
      </div>
    </div>

  </form>

</template>

<script>
import submitForm from '~/lib/submitForm.js'

import strings from './strings.json'
import FullNameField from './FullNameField.vue'
import EmailField from './EmailField.vue'
import PhoneField from './PhoneField.vue'

export default {
  components: {
    FullNameField,
    EmailField,
    PhoneField,
  },
  props: {
    requestedContent: String,
    whenSubmitted: Function,
  },
  inject: ['locale'],
  data() {
    return {
      submissionStatus: 'unsubmitted',
    }
  },
  computed: {
    disabled() {
      return this.submissionStatus === 'submitting'
    },
    localeStrings() {
      return strings[this.locale]
    },
  },
  methods: {
    submitForm() {
      if (typeof window !== 'undefined') {
        const fullNameRef = this.$refs.fullName
        const emailRef = this.$refs.email
        const phoneRef = this.$refs.phone
        fullNameRef.checkInvalid()
        emailRef.checkInvalid()
        phoneRef.checkInvalid()
        const valid = fullNameRef.status === 'valid' && emailRef.status === 'valid' && phoneRef.status === 'valid'
        if (valid) {
          const submissionData = {
            requestedResource: this.requestedContent,
            fullName: fullNameRef.value,
            email: emailRef.value,
            phone: phoneRef.value,
            digitalLeadType: "Nurture campaign ebook",
          }
          this.submissionStatus = 'submitting'
          submitForm({ variant: 'ebook', locale: this.locale }, submissionData)
            .then((response) => {
              if (response.ok) {
                this.submissionStatus = 'submitted'
                this.whenSubmitted?.()
              }
              else {
                this.submissionStatus = 'failed'
              }
            })
            .catch(() => {
              this.submissionStatus = 'failed'
            })
        }
      }
    },
  }
}
</script>

<style scoped>

.button {

  border-radius: 4px;
  padding: var(--spacing-4) var(--spacing-7);
  background-color: var(--bg-color-dark-blue);
  width: 100%;

  font-weight: 500;
  font-size: var(--font-size-2);
  line-height: 1;
  color: var(--text-color-white);

  transition: all 0.15s;
}

.button:not(:disabled):hover {
  background-color: #0081d6;
}

.button:disabled {
  opacity: 0.25;
}

.formFooter {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-2);
}

.statusMessageSubmitted::before {
  content: url("../images/success.svg");
  float: left;
  margin-right: var(--spacing-3);
}

.submittedText {
  font-weight: 500;
  font-size: var(--font-size-3);
  color: var(--text-color-black);
}

.statusMessageFailed {
  margin-top: var(--spacing-5);
  font-size: var(--font-size-1);
  color: var(--text-color-black);
}

.formFields {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-2);
}

.formFields + .formFooter {
  margin-top: var(--spacing-7);
}
</style>
